<template>
  <app-page>
    <template #actions>
      <app-icon-button icon="refresh" label="Aktualisieren" @click="refreshDataGrid" />
      <app-button v-if="gridTouch" icon="upload" @click="$refs.fileInput.click()">Hochladen</app-button>
      <app-icon-button
        v-else
        icon="upload"
        label="Bestellliste hochladen"
        @click="$refs.fileInput.click()"
      />
    </template>
    <template #toolbar-end>
      <app-search
        v-model="searchText"
        placeholder="In Bestellungen suchen"
        @input="onSearchInput"
      />
    </template>
    <dx-data-grid
      :ref="gridRefName"
      :data-source="dataSource"
      :columns="columns"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      :column-auto-width="true"
      :hover-state-enabled="!gridTouch"
      :allow-column-reordering="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :remote-operations="true"
      :scrolling="scrolling"
      :element-attr="gridAttr"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <dx-search-panel :visible="false" />

      <dx-editing
        refresh-mode="full"
        :allow-adding="false"
        :allow-updating="false"
        :allow-deleting="false"
        mode="batch"
      />

      <dx-pager
        :show-page-size-selector="false"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
        :visible="true"
        :info-text="'Seite {0} von {1} ({2} Schüler)'"
        :show-navigation-buttons="true"
      />
      <dx-filter-row :visible="true" />
      <dx-paging :page-size="10" />
      <dx-export :enabled="false" />
    </dx-data-grid>

    <input
      type="file"
      ref="fileInput"
      style="display: none"
      accept=".xls, .xlsx, .csv"
      v-on:change="onFileUploadChanged($event)"
    />

    <!-- Toasts unten rechts wie bei PayPal (Kundenwunsch 13.10.2026) -->
    <app-toast v-model="showLoadingSnackbar" :timeout="0" icon="upload" text="Daten werden importiert …" indeterminate />
    <app-toast v-model="showSuccessSnackbar" icon="check" kind="ok" text="Import erfolgreich." closable />
    <app-toast
      v-model="showErrorSnackbar"
      :timeout="0"
      icon="alertTriangle"
      kind="error"
      text="Import fehlgeschlagen."
      closable
    />
  </app-page>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxEditing,
  DxSearchPanel,
  DxExport,
} from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";
import DataSource from "devextreme/data/data_source";
import axios from "axios";

export default {
  components: {
    DxDataGrid,
    DxPager,
    DxFilterRow,
    DxPaging,
    DxEditing,
    DxSearchPanel,
    DxExport,
  },
  mixins: [DataGridMixin],
  computed: {},
  watch: {},
  data() {
    return {
      gridRefName: "eticketOrdererGrid",
      searchText: "",
      gridAttr: {},
      showLoadingSnackbar: false,
      showSuccessSnackbar: false,
      showErrorSnackbar: false,
      columns: [
        {
          dataField: "orderer_id",
          caption: "Besteller ID",
          dataType: "number",
        },
        {
          dataField: "transportation_company_1",
          caption: "Verkehrsunternehmen",
        },
        {
          dataField: "line_1",
          caption: "Linie 1",
        },
        {
          dataField: "transportation_company_2",
          caption: "Verkehrsunternehmen 2",
        },
        {
          dataField: "line_2",
          caption: "Linie 2",
        },
        {
          dataField: "transportation_company_3",
          caption: "Verkehrsunternehmen 3",
        },
        {
          dataField: "line_3",
          caption: "Linie 3",
        },
        {
          dataField: "student_id",
          caption: "Schüler ID",
        },
        {
          dataField: "mail",
          caption: "E-Mail",
        },
        {
          dataField: "last_name",
          caption: "Name",
        },
        {
          dataField: "first_name",
          caption: "Vorname",
        },
        {
          dataField: "birthday",
          caption: "Geburtsdatum",
        },
        {
          dataField: "zip",
          caption: "PLZ",
          dataType: "number",
        },
        {
          dataField: "city",
          caption: "Ort",
        },
        {
          dataField: "school",
          caption: "Schule",
        },
        {
          dataField: "class",
          caption: "Klasse",
        },
        {
          dataField: "boarding_stop_name",
          caption: "Einstieg",
        },
        {
          dataField: "boarding_stop_city",
          caption: "Einstieg Ort",
        },
        {
          dataField: "boarding_stop_DHID",
          caption: "Einstieg DHID",
        },
        {
          dataField: "boarding_zone",
          caption: "Einstieg Zone",
        },
        {
          dataField: "exit_stop_name",
          caption: "Ausstieg Name",
        },
        {
          dataField: "exit_stop_city",
          caption: "Ausstieg Ort",
        },
        {
          dataField: "exit_stop_DHID",
          caption: "Ausstieg DHID",
        },
        {
          dataField: "exit_stop_zone",
          caption: "Ausstieg Zone",
        },
        {
          dataField: "tariff_level",
          caption: "Tarifstufe",
        },
        {
          dataField: "valid_from",
          caption: "Gültigkeit Beginn",
        },
        {
          dataField: "valid_to",
          caption: "Gültigkeit Ende",
        },
        {
          dataField: "terminated_at",
          caption: "Datum Kündigung",
        },
        {
          dataField: "price",
          caption: "Preis Ticket",
          dataType: "number",
        },
        {
          dataField: "reference_tariff_price",
          caption: "Preis Referenztarif",
          dataType: "number",
        },
      ],
      dataSource: new DataSource({
        load: async (loadOptions) => {
          console.log({ loadOptions });
          const data = (
            await axios.get(
              `${
                this.$store.state.baseUrl
              }eticket-orderlist?loadOptions=${encodeURIComponent(
                JSON.stringify(loadOptions)
              )}`
            )
          ).data;
          return data;
        },
      }),
    };
  },
  methods: {
    refreshDataGrid() {
      this.$refs[this.gridRefName].instance.refresh();
    },
    // Suche, Aktualisieren und Hochladen stehen in Seitenkopf und Werkzeugleiste; die DX-Werkzeugleiste bleibt leer
    onToolbarPreparing(e) {
      e.toolbarOptions.items = [];
    },
    onSearchInput() {
      this.$refs[this.gridRefName].instance.searchByText(this.searchText);
    },
    async onFileUploadChanged(e) {
      try {
        this.showLoadingSnackbar = true;
        this.showSuccessSnackbar = false;
        this.showErrorSnackbar = false;

        const file = e.target.files[0];
        e.target.value = "";
        const base64 = await this.convertBase64(file);

        await axios.post(`${this.$store.state.baseUrl}eticket-orderlist`, {
          data: base64,
        });
        this.refreshDataGrid();
        this.showSuccessSnackbar = true;
      } catch (e) {
        this.showErrorSnackbar = true;
      } finally {
        this.showLoadingSnackbar = false;
      }
    },
    convertBase64(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
          resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    },
    wait(milliseconds) {
      return new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
      });
    },
  },
};
</script>
